module.exports = __webpack_public_path__ + "media/images/landing/crime/product-3-7939f24c788efbb1118cbccdc44f552e.png";